// extracted by mini-css-extract-plugin
module.exports = {"container":"BannerWithIcon_container__3R3pr","banner":"BannerWithIcon_banner__1y6AM","iconContainer":"BannerWithIcon_iconContainer__YkJPF","title":"BannerWithIcon_title__1-vOk"};